import { render, staticRenderFns } from "./SbolTreeList.vue?vue&type=template&id=15684488&scoped=true&"
import script from "./SbolTreeList.vue?vue&type=script&lang=js&"
export * from "./SbolTreeList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolTreeList.vue?vue&type=style&index=0&id=15684488&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15684488",
  null
  ,true
)

export default component.exports